import useDefinedContext from "hooks/useDefinedContext";
import { LineData } from "components/charting/types/Chart.types";
import ChartDataContext from "components/charting/contexts/ChartDataContext";

function useChartData(): LineData[] {
  return useDefinedContext(ChartDataContext);
}
export default useChartData;
